/**
 * The Sort model class
 */
export class Sort {
  private fieldName: string;
  private sortDirection: SortDirections;

  /**
   * Create a new Sort
   * @param fieldName The field name
   * @param sortDirection The sort direction
   */
  constructor(fieldName: string, sortDirection: SortDirections) {
    this.fieldName = fieldName;
    this.sortDirection = sortDirection;
  }

  get FieldName(): string {
    return this.fieldName;
  }

  get SortDirection(): SortDirections {
    return this.sortDirection;
  }

  get SortDescending(): boolean {
    return this.SortDirection === SortDirections.Descending;
  }

  public ToDataQuery() {
    return `${this.fieldName} ${this.sortDirection}`;
  }
}

export enum SortDirections {
  Ascending = "asc",
  Descending = "desc"
}